// components
import SkeletonNoData from 'src/components/skeleton/SkeletonNoData';
import SimpleStatsTile from 'src/components/reporting/SimpleStatsTile';

// ----------------------------------------------------------------------

interface Props {
  dataset: any;
  isLoading: boolean;
  link?: string;
  text?: string;
  hidePlaceholder?: boolean;
}

const Summary: React.FC<Props> = ({ dataset, isLoading, link, text, hidePlaceholder }) => {

  return (
      <SkeletonNoData
        isLoading={isLoading}
        hasData={dataset?.totalOffsets > 0}
        height={260}
        text={hidePlaceholder && text ? text : ''}
        hideInfo
      >
        {dataset && <SimpleStatsTile data={dataset} />}
      </SkeletonNoData>
  );
};

export default Summary;
